import ViewWorker from "../../../../components/@users/workers/ViewWorker";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WorkerViewPage() {

    return (
        <ViewWorker 
            routeType={routeTypes.admin}
        />
    )
}       